import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog'
import { NewJobScreen, type NewJobInitialValues } from '@/screens/NewJobScreen'

export function NewJobModal({
  open = false,
  onOpenChange,
  onSave,
  errorMessage,
}: {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  onSave?: (values: NewJobInitialValues) => void | Promise<void>
  errorMessage?: string | null
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[1200px]">
        <DialogTitle>New Job</DialogTitle>
        <DialogDescription>Add a new in-house job.</DialogDescription>
        <NewJobScreen
          errorMessage={errorMessage}
          onSave={onSave}
          onCancel={() => onOpenChange?.(false)}
        />
      </DialogContent>
    </Dialog>
  )
}
